/* Pookie's Pal - red "Sale" badge effects.
   Added 2026-09-28. Loaded deferred from snippets/pp-head.liquid.

   1. FIREWORK (once per badge, per page view)
      The first time a Sale badge scrolls into view it pops and a premium-style
      burst goes off: a gold shockwave ring, light streaks shooting outward,
      then twinkling glitter and star sparkles that drift down. A smaller
      second burst follows. ~2.2 seconds in total.
      Everything is drawn on ONE fixed, click-through <canvas> on top of the
      page, so nothing is hidden or moved, taps are never blocked, and phones
      never get sideways scroll. The canvas loop only runs while sparks exist.

   2. SCROLL TILT - removed 2026-09-28 at the owner's request.

   Only .color-custom-badge-sale badges are touched (never "Sold out").
   Visitors with "reduce motion" switched on don't get the firework. */

(function () {
  if (window.__ppSaleFireworks) return;
  window.__ppSaleFireworks = true;

  var SELECTOR = '.product-badges__badge.color-custom-badge-sale';
  var RED = '#e32c2b';
  var GOLD = '#f7c948';
  var PALETTE = ['#e32c2b', '#ff6b5b', '#f7c948', '#ffe29a', '#fff4d6', '#ff9f43'];

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var badges = [];

  /* ---------------------------------------------------------------- */
  /* Canvas layer                                                      */
  /* ---------------------------------------------------------------- */

  var canvas = null;
  var ctx = null;
  var dpr = 1;
  var effects = [];
  var running = false;
  var lastTime = 0;

  function ensureCanvas() {
    if (canvas && canvas.isConnected) return true;
    canvas = document.createElement('canvas');
    canvas.className = 'pp-fw-layer';
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = 'position:fixed;left:0;top:0;width:100vw;height:100vh;pointer-events:none;z-index:40;';
    document.body.appendChild(canvas);
    ctx = canvas.getContext('2d');
    if (!ctx) return false;
    sizeCanvas();
    return true;
  }

  function sizeCanvas() {
    if (!canvas) return;
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(window.innerWidth * dpr);
    canvas.height = Math.round(window.innerHeight * dpr);
  }
  window.addEventListener('resize', sizeCanvas);

  function rand(a, b) { return a + Math.random() * (b - a); }
  function pick(list) { return list[(Math.random() * list.length) | 0]; }

  /* One burst = ring + streaks + glitter, all positioned relative to the
     badge centre so they stay attached if the page scrolls mid-burst. */
  function makeBurst(scale, delay) {
    var streaks = [];
    var glitter = [];
    var nStreaks = Math.round(14 * scale);
    var nGlitter = Math.round(42 * scale);
    var i, a, s;

    for (i = 0; i < nStreaks; i++) {
      a = (Math.PI * 2 * i) / nStreaks + rand(-0.12, 0.12);
      streaks.push({ a: a, speed: rand(5.5, 8) * scale, len: rand(14, 24) * scale, color: i % 2 ? GOLD : RED, width: rand(1.8, 2.8) });
    }
    for (i = 0; i < nGlitter; i++) {
      a = rand(0, Math.PI * 2);
      s = rand(1.5, 6.5) * scale;
      glitter.push({
        x: 0, y: 0, vx: Math.cos(a) * s, vy: Math.sin(a) * s,
        size: rand(1.2, 3.2), star: Math.random() < 0.3,
        color: pick(PALETTE), phase: rand(0, Math.PI * 2), life: rand(1300, 1900)
      });
    }
    return { t: -delay, scale: scale, streaks: streaks, glitter: glitter };
  }

  function fire(badge) {
    if (!ensureCanvas()) return;
    effects.push({ badge: badge, bursts: [makeBurst(1.25, 0), makeBurst(0.8, 480)], age: 0 });

    if (badge.animate) {
      badge.animate(
        [{ scale: '1' }, { scale: '1.35', offset: 0.35 }, { scale: '0.95', offset: 0.7 }, { scale: '1' }],
        { duration: 600, easing: 'ease-out' }
      );
    }
    if (!running) {
      running = true;
      lastTime = performance.now();
      window.requestAnimationFrame(tick);
    }
  }

  function drawStar(x, y, r) {
    ctx.beginPath();
    ctx.moveTo(x, y - r * 2.2);
    ctx.quadraticCurveTo(x, y, x + r * 2.2, y);
    ctx.quadraticCurveTo(x, y, x, y + r * 2.2);
    ctx.quadraticCurveTo(x, y, x - r * 2.2, y);
    ctx.quadraticCurveTo(x, y, x, y - r * 2.2);
    ctx.fill();
  }

  function drawBurst(b, cx, cy, dt) {
    b.t += dt;
    if (b.t < 0) return true;
    var t = b.t;
    var alive = false;

    /* Shockwave ring: 0-550ms */
    if (t < 550) {
      alive = true;
      var p = t / 550;
      var ease = 1 - Math.pow(1 - p, 3);
      ctx.globalAlpha = (1 - p) * 0.9;
      ctx.strokeStyle = GOLD;
      ctx.lineWidth = 2.5 * (1 - p) + 0.5;
      ctx.beginPath();
      ctx.arc(cx, cy, 8 + ease * 70 * b.scale, 0, Math.PI * 2);
      ctx.stroke();
    }

    /* Streaks: 0-700ms, shoot out and decelerate */
    if (t < 700) {
      alive = true;
      var q = t / 700;
      var dist = (1 - Math.pow(1 - q, 3)) * 95 * b.scale;
      ctx.lineCap = 'round';
      for (var i = 0; i < b.streaks.length; i++) {
        var s = b.streaks[i];
        var d = dist * (s.speed / (7 * b.scale));
        var len = s.len * (1 - q);
        var cos = Math.cos(s.a), sin = Math.sin(s.a);
        ctx.globalAlpha = 1 - q;
        ctx.strokeStyle = s.color;
        ctx.lineWidth = s.width * (1 - q * 0.7);
        ctx.beginPath();
        ctx.moveTo(cx + cos * (12 + d), cy + sin * (12 + d));
        ctx.lineTo(cx + cos * (12 + d + len), cy + sin * (12 + d + len));
        ctx.stroke();
      }
    }

    /* Glitter: physics with drag + gravity + twinkle */
    var f = dt / 16.67;
    for (var j = 0; j < b.glitter.length; j++) {
      var g = b.glitter[j];
      if (t > g.life) continue;
      alive = true;
      g.vx *= Math.pow(0.93, f);
      g.vy = g.vy * Math.pow(0.93, f) + 0.09 * f;
      g.x += g.vx * f;
      g.y += g.vy * f;
      var fade = 1 - t / g.life;
      var twinkle = 0.55 + 0.45 * Math.sin(g.phase + t / 70);
      ctx.globalAlpha = Math.max(0, fade * twinkle);
      ctx.fillStyle = g.color;
      if (g.star) {
        drawStar(cx + g.x, cy + g.y, g.size * (0.6 + fade * 0.6));
      } else {
        ctx.beginPath();
        ctx.arc(cx + g.x, cy + g.y, g.size * (0.5 + fade * 0.5), 0, Math.PI * 2);
        ctx.fill();
      }
    }
    return alive;
  }

  function tick(now) {
    var dt = Math.min(now - lastTime, 50);
    lastTime = now;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.globalCompositeOperation = 'source-over';

    effects = effects.filter(function (e) {
      var r = e.badge.getBoundingClientRect();
      var cx = r.left + r.width / 2;
      var cy = r.top + r.height / 2;
      var alive = false;
      for (var i = 0; i < e.bursts.length; i++) {
        if (drawBurst(e.bursts[i], cx, cy, dt)) alive = true;
      }
      return alive && e.badge.isConnected;
    });
    ctx.globalAlpha = 1;

    if (effects.length) {
      window.requestAnimationFrame(tick);
    } else {
      running = false;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      io.unobserve(entry.target);
      fire(entry.target);
    });
  }, { threshold: 0.9 }) : null;

  /* ---------------------------------------------------------------- */
  /* Finding badges (also ones rendered later)                         */
  /* ---------------------------------------------------------------- */

  function scan() {
    badges = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    for (var i = 0; i < badges.length; i++) {
      if (badges[i].hasAttribute('data-pp-fw')) continue;
      badges[i].setAttribute('data-pp-fw', '1');
      if (io) io.observe(badges[i]);
    }
  }

  var queued = false;
  function queueScan(mutations) {
    if (queued) return;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].target !== document.body || mutations[i].addedNodes[0] !== canvas) {
        queued = true;
        window.requestAnimationFrame(function () { queued = false; scan(); });
        return;
      }
    }
  }

  function start() {
    scan();
    new MutationObserver(queueScan).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
